import { FC, forwardRef, Ref } from 'react';
import { IonContent, useIonPopover as useIonPopoverIonic } from '@ionic/react';
import { AlliePopoverProps } from './Popover.types';
import { StyledPopover } from './Popover.styles';

export const AlliePopover: FC<AlliePopoverProps> = forwardRef(
  ({ arrow = false, shadow = true, content, ...props }, ref) => (
    <StyledPopover
      arrow={arrow}
      shadow={shadow}
      ref={ref as Ref<HTMLIonPopoverElement>}
      {...props}
    >
      {content && <IonContent forceOverscroll={false} {...content} />}
    </StyledPopover>
  )
);

export const useIonPopover = useIonPopoverIonic;